"use client";
import React, { useEffect, useState } from "react";
import { Modal } from "react-bootstrap";
import CommonButton from "./CommonButton";
import Image from "next/image";
import partyPopper from "../assets/party-popper.json";
import Lottie from "lottie-react";
import Link from "next/link";
import { usersPerformance } from "@/services/pricing";
import { useRouter } from "next/navigation";

const GreetingModal = ({
  show,
  onHide,
  onUpdate,
  selectedPackageId,
  quoteId,
}) => {
  const route = useRouter();
  const [showCloseButton, setShowCloseButton] = useState(false);
  useEffect(() => {
    const timer = setTimeout(() => {
      setShowCloseButton(true);
    }, 5000); // Show close button after 5 seconds

    return () => clearTimeout(timer);
  }, []);
  return (
    <Modal
      show={show}
      onHide={onHide}
      centered
      backdrop="static"
      keyboard={false}
    >
      {/* <Modal.Header className="border-0"></Modal.Header> */}
      <Modal.Body className="pt-0 GreetingModalMain">
        <div
          className="animation-wrapper"
          style={{ maxWidth: 400, margin: "0 auto" }}
        >
          <Lottie animationData={partyPopper} />
        </div>
        <div className="modal-title text-center mt-3">
          You're All Set <span>— Let's Bring Your Vision to Life!</span>
        </div>
        <p className="text-center p-0 m-0">
          Thank you for confirming your details! Our team has received your
          request and will get in touch within the next 24 hours to discuss the
          next steps.
        </p>
        <div className="or-tag">
          <span>Or</span>
        </div>
        <p className="text-center">
          If you'd like to skip the wait, feel free to schedule a call right now
          and secure a dedicated slot with our experts.
        </p>
        <div className="d-flex justify-content-center gap-3 align-items-center">
          <Link
            href={"https://calendly.com/greet_at_neoverce/30min"}
            role="button"
            target="_blank"
            aria-label={`Schedule Call`}
          >
            <CommonButton
              label="Schedule call"
              className="btn-primary"
              onClick={async () => {
                // await onUpdate();
                localStorage.clear();
                route?.push("/pricing");
                onHide();
              }}
            />
          </Link>
          {showCloseButton && (
            <Link
              href={"/"}
              role="button"
              aria-label={`back to home`}
              className="back-to-home"
            >
              Back to Home
            </Link>
          )}
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default GreetingModal;
